// App.js
import { useState, useEffect, useContext } from "react";
import { jwtDecode as jwt_decode } from "jwt-decode";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useSearchParams,
} from "react-router-dom";
// import InvoiceTable from "./components/InvoiceTable";

import "./scss/ehsibly.scss";

import Register from "./components/Register";
import Login from "./components/Login";
import IssuedAndImportedBooks from "./pages/merchant-pages/IssuedAndImportedBooks";
import IssuedBooks from "./pages/merchant-pages/IssuedBooks";

import InvoicesManagement from "./pages/user-pages/InvoicesManagement";
import ContainerPrices from "./pages/user-pages/ContainerPrices";
import ViewInvoice from "./pages/user-pages/ViewInvoice";
import PrintInvoices from "./pages/user-pages/PrintInvoices";
import DataProvider from "./utils/DataContext";
import ScrollToTop from "./components/ScrollToTop";
import PrintDocuments from "./components/PrintDocuments";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import useLanguage from "./utils/useLanguage";
import Profile from "./pages/user-pages/Profile";
import VerifyEmail from "./pages/general-pages/VerifyEmail";
import ResetPassword from "./pages/general-pages/ResetPassword";
import SuccessPage from "./pages/general-pages/SuccessPage";
import SuppliersPage from "./pages/user-pages/SuppliersPage";
import Employees from "./pages/merchant-pages/Employees";
import ClinicEmployees from "./pages/clinic-pages/ClinicEmployees";
import InvoicesOfShippedContainers from "./pages/merchant-pages/invoicesOfMulti/InvoicesOfShippedContainers";
import Development from "./pages/Development";
import AdminsLogin from "./pages/admin-pages/AdminsLogin";
import UsersPage from "./pages/admin-pages/UsersPage";
import AdminsPage from "./pages/admin-pages/AdminsPage";
import UserAuthProvider, { UserAuth } from "./utils/AuthContext";
import EditContainer from "./pages/user-pages/EditContainer";
import CustomersPage from "./pages/general-pages/CustomersPage";
import SubCompanies from "./pages/merchant-pages/SubCompanies";
import OrgShippedContainers from "./pages/merchant-pages/OrgShippedContainers";
import NoCustomerContainers from "./pages/merchant-without-customer/NoCustomerContainers";
import ViewNoCustomerContainer from "./pages/merchant-without-customer/ViewNoCustomerContainer";
import ViewShippedContainer from "./pages/merchant-pages/ViewShippedContainer";
import CreateInvoiceOfMultiContsPage from "./pages/merchant-pages/CreateInvoiceOfMultiContsPage";
import MessagePage from "./pages/general-pages/MessagePage";
import BankApplications from "./pages/merchant-pages/BankApplications";
import MissingPage from "./pages/MissingPage";
import AnalyzePdf from "./pages/AnalyzePdf";
import ViewMultiContainerInvoice from "./pages/merchant-pages/invoiceOfMulti/ViewMultiContainerInvoice";
import AnalyzedInvoice from "./pages/merchant-pages/AnalyzedInvoice";

import Appointments from "./pages/clinic-pages/Appointments";
import ItemInvoices from "./pages/item-invoice/ItemInvoices";
import ViewItemInvoice from "./pages/item-invoice/View-item-invoice/ViewItemInvoice";
import PreviewItemInvoice from "./pages/item-invoice/View-item-invoice/PreviewItemInvoice";
import PreviewItemInvoiceTemplate from "./pages/item-invoice/View-item-invoice/PreviewItemInvoiceTemplate";

import CalculateAttendance from "./pages/attendance-system/CalculateAttendance";
import CashierSystem from "./pages/cashier-system/CashierSystem";

import DoctorsPage from "./pages/clinic-pages/DoctorsPage";

import TreatmentsPage from "./pages/clinic-pages/TreatmentsPage";
import Inventory from "./pages/cashier-system/Inventory";
import Cashier from "./pages/cashier-system/Cashier";
import AbstractCustomersPage from "./pages/general-pages/AbstractCustomersPage";
import PatientsPage from "./pages/clinic-pages/PatientsPage";
import ProjectDashboard from "./pages/attendance-system/Projects";
import ManualCashier from "./pages/manual-cashier-system/ManualCashier";
import PatientProfile from "./pages/clinic-pages/PatientProfile";

import TodoListPage from "./pages/ehsibly-special/todoList.js";
import WhatsAppPage from "./pages/admin-pages/WhatsApp";
import ManageRulersAndColors from "./pages/fabric-store/ManageRulersAndColors";
import AddFabricOrderPage from "./pages/fabric-store/AddFabricOrderPage";
import CompleteFabricOrders from "./pages/fabric-store/CompleteFabricOrders";
import InCompleteFabricOrders from "./pages/fabric-store/IncompleteFabricOrders";
import SellInvoices from "./pages/cashier-system/SellInvoices";

import EmployeesAttendance from "./pages/attendance-system/EmployeesAttendance";
import EmployeeAttendancePage from "./pages/attendance-system/EmployeeAttendancePage";

import FabricOrderPage from "./pages/fabric-store/FabricOrderPage";
import FabricCustomers from "./pages/fabric-store/FabricCustomers.js";
import ManualCustomersCashier from "./pages/manual-cashier-system/View-item-invoice/ManualCustomersCashier";
import ColorPage from "./pages/fabric-store/ColorPage";
import FabricStoreCashier from "./pages/fabric-store/FabricStoreCashier";
import NoCustomerInvoices from "./pages/merchant-without-customer/NoCustomerInvoices/NoCustomerInvoices";
import ViewNoCustomerInvoice from "./pages/merchant-without-customer/NoCustomerInvoice/ViewNoCustomerInvoice";
import CreateNoCustomerInvoice from "./pages/merchant-without-customer/CreateNoCustomerInvoice";

import EmployeesProgress from "./pages/attendance-system/EmployeesProgress.js";

import FabricSellInvoices from "./pages/fabric-store/FabricSellInvoices.js";

import BugReportsList from "./pages/admin-pages/BugReportsList";
import BugReportDetails from "./pages/admin-pages/BugReportDetails";
import AnalyzedNoCustomerInvoice from "./pages/merchant-without-customer/AnalyzedNoCustomerInvoice.js";
import FabricCustomersCashier from "./pages/fabric-store/FabricCustomersCashier.js";
import ViewSellInvoice from "./pages/fabric-store/ViewSellInvoice.js";
import PaperRulers from "./pages/papers-factory/PaperRulers.js";
import ManagePaperRulers from "./pages/papers-factory/ManagePaperRulers.js";
import AddPaperOrderPage from "./pages/papers-factory/AddPaperOrderPage.js";
import IncompletePaperOrders from "./pages/papers-factory/IncompletePaperOrders.js";
import CompletedPaperOrders from "./pages/papers-factory/CompletedPaperOrders.js";
import PaperOrderPage from "./pages/papers-factory/PaperOrderPage.js";
import PaperStoreCashier from "./pages/papers-factory/PaperStoreCashier.js";
import PaperCustomersCashier from "./pages/papers-factory/PaperCustomersCashier.js";
import ViewPaperSellInvoice from "./pages/papers-factory/ViewPaperSellInvoice.js";
import PaperSellInvoices from "./pages/papers-factory/PaperSellInvoices.js";
import PaperPage from "./pages/papers-factory/PaperPage.js";
import PendingOrders from "./pages/papers-factory/PendingOrders.js";
import PaperInvoicePage from "./pages/papers-factory/PaperInvoicePage.js";
import PreparedOrders from "./pages/papers-factory/PreparedOrders.js";
import IraqiBanksPage from "./pages/general-pages/IraqiBanksPage.js";
import BanksPage from "./pages/general-pages/BanksPage.js";
import OrganizationsPage from "./pages/admin-pages/OrganizationsPage.js";
import InternalInCompletePaperOrders from "./pages/papers-factory/internal-orders/InternalIncompletePaperOrders.js";
import InternalCompletedPaperOrders from "./pages/papers-factory/internal-orders/InternalCompletedPaperOrders.js";
import InternalPaperOrderPage from "./pages/papers-factory/internal-orders/InternalPaperOrderPage.js";
import InternalAddPaperOrderPage from "./pages/papers-factory/internal-orders/InternalAddPaperOrderPage.js";
import BanksWithTransaction from "./pages/general-pages/BanksWithTransaction.js";
import StudentsPage from "./pages/school/StudentsPage.js";
import EducationStagesPage from "./pages/school/EducationalStagesPage.js";
import DiscountsPage from "./pages/school/DiscountsPage.js";
import StudentProfile from "./pages/school/StudentProfile.js";
import KassatPage from "./pages/general-pages/KassatPage.js";
import BooksPage from "./pages/school/BooksPage.js";
import BookPage from "./pages/school/BookPage.js";
import KassaPage from "./pages/general-pages/KassaPage.js";
import ProductPage from "./pages/general-pages/ProductHistoryPage.js";
import AddSchoolOrder from "./pages/school/purchases/AddSchoolOrder.js";
import AddBookOrder from "./pages/school/purchases/AddBookOrder.js";
import InCompleteProductOrders from "./pages/school/purchases/InCompleteProductOrders.js";
import ProductOrdersPage from "./pages/school/purchases/ProductOrdersPage.js";
import CompletedProductOrders from "./pages/school/purchases/CompleteProductOrders.js";
import BanksAnalyzeInvoice from "./pages/banks/BanksAnalyzeInvoice.js";
import BanksInvoicesApplications from "./pages/banks/BanksInvoicesApplications.js";
import ForeignBanks from "./pages/banks/ForeginBanks.js";
import SubscriptionPlans from "./pages/admin-pages/SubscriptionPlans.js";
import ManageSubscriptions from "./pages/admin-pages/ManageSubscriptions.js";
import Belongings from "./pages/general-pages/Belongings.js";
import BankSuppliersPage from "./pages/banks/BankSuppliersPage.js";
import BankIraqiCompaniesPage from "./pages/banks/BankIraqiCompanies.js";
import UniformPage from "./pages/school/UniformPage.js";
import AddOrder from "./pages/school/AddOrderPage.js";
import AddUniformOrder from "./pages/school/purchases/AddUniformOrder.js";
import AddSuppliesOrder from "./pages/school/AddSuppliesOrder.js";
import DeliveredSuppliesPage from "./pages/school/DeliveredSupplies.js";
import DeliveredSuppliesItmePage from "./pages/school/DeliveredSuppliesItem.js";
import StudentSupplies from "./pages/school/StudentSupplies.js";
import ExpensesPage from "./pages/school/Expenses.js";
import RevenuesPage from "./pages/school/Revenues.js";
import AIOrganizationInvoicesPage from "./pages/ai-organization/AIOrganizationInvoicesPage.js";
import AIOrganizationInvoicePage from "./pages/ai-organization/AIOrganizationInvoicePage.js";
import BankInvoicesPage from "./pages/banks/BankInvoicesPage.js";
import BankInvoicePage from "./pages/banks/BankInvoicePage.js";
import ViewInvoicePage from "./pages/ai-organization/ViewInvoice.js";
import ViewInvoicePaymentsPage from "./pages/ai-organization/ViewInvoicePaymentsPage.js";
import BanksInvoicesApplicationPayments from "./pages/ai-organization/BanksInvoicesApplicationPayments.js";
import BanksInvoicesApplicationPaymentDetails from "./pages/ai-organization/BanksInvoicesApplicationPaymentDetails.js";
import EntitlementsPage from "./pages/school/EntitlementsPage.js";
import EmployeeEntitlementsPage from "./pages/school/EmployeeEntitlementsPage.js";
import DeductionsPage from "./pages/school/DeductionsPage.js";
import HsCodePage from "./pages/admin-pages/HsCodePage.js";
import ViewSubCompany from "./pages/banks/BankSubcompanyPage.js";
import ViewSupplier from "./pages/banks/BankSupplierPage.js";
import CompanyAnalyzeApplicationPage from "./pages/merchant-pages/CompanyAnalyzeApplicationPage.js";
import S3FileManagement from "./pages/admin-pages/S3FileManagement.js";
import RamadanDecoration from "./components/RamadanDecoration.js";

const Layout = ({ element, showHeader, setIsAuthenticated }) => {
  const [sidebarPinned, setSidebarPinned] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const { currentDirection } = useLanguage();
  const isRTL = currentDirection === "rtl";

  return (
    <DataProvider>
      <RamadanDecoration position={currentDirection === "rtl" ? "top-left" : "top-right" }/>
      {showHeader && <Header setIsAuthenticated={setIsAuthenticated} />}
      {showHeader ? (
        <div className={`c-sidebar-layout ${isRTL ? "c-sidebar-layout--rtl" : ""}`}>
          <Sidebar onPinnedChange={setSidebarPinned} onExpandedChange={setSidebarExpanded} />
          <main
            className={`c-sidebar-layout__content ${sidebarPinned ? "c-sidebar-layout__content--pinned" : ""} `}
          >
            {element}
          </main>
        </div>
      ) : (
        element
      )}
      {showHeader && <ScrollToTop sidebarExpanded={sidebarExpanded} />}
    </DataProvider>
  );
};
const App = () => {
  const getShowHeader = (path) => {
    const headerRoutes = [
      "/dashboard",
      "/containerPrices",
      "/invoice/:id",
      "/print",
      "/printDocuments",
      "/profile",
      "/issuedBooks",
      "/importedBooks",
      "/employees",
      "/clinicEmployees",
      "/message-page",
      "/development",
      "/clinic-dashboard",
      "/merchant-dashboard",
      "/development",
      "/viewSuppliersPage",
      "/customers",
      "/subCompanies",
      "/orgShippedContainers",
      "/invoicesOfShippedContainers",
      "/editContainer/:id",
      "/shippedContainer/:id",
      "/analyzepdf",
      "/appointments",
      "/doctors",
      "/treatmentsPage",
      "/itemInvoices",
      "/ItemInvoice",
      "/supermarket-dashboard",
      "/cashier",
      "/inventory",
      "/manual-cashier",
      "/whatsapp-page",
      "/todolist-page",
      "/hs-codes-page",
      "/patient-profile",
      "/fabricstore-dashboard",
      "/rulers",
      "/incompleteFabricOrders-page",
      "/completeFabricOrders-page",
      "fabric-order-page",
      "/addFabricOrder-page",
      "/sell-invoices",
      "/fabric-sellInvoices",

      "/calculate-attendance",
      "/attendance-employees",
      "/employee-attendance/:id",

      "/manual-customers-cashier",
      "/rulers/color-page/:id",
      "/fabric-cashier",
      "/admin-dashboard",
      "/attendance-dashboard",
      "/fabric-customers-cashier",
      "/fabric-sell-invoice/:id",

      "/paperFactory-dashboard",
      "/manage-paper-rulers",
      "/paper-rulers",
      "/add-paper-order",
      "/incomplete-paper-order",
      "/completed-paper-orders",
      "/paper-order-page",
      "/paper-store-cashier",
      "/paper-customer-cashier",
      "/paper-sellInvoices",
      "/paper-sell-invoice/:id",
      "/manage-paper-rulers/paper-page/:id",
      "/pending-orders",
      "/completed-orders",
      "/pending-orders/paper-invoice/:id",
      "/prepared-orders",

      "/banks-page",
      "/iraqi-banks-page",
      "/organizations-page",

      "/add-internal-order-page",
      "/incomplete-internal-orders",
      "/completed-internal-orders",
      "/internal-paper-order-page/:id",
      "/banks-with-transactions",
      "/forget-password",
      "/school-dashboard",
      "/students",
      "/education-stages",
      "/discounts-page",
      "/student-profile/:id",
      "/kassat-page",
      "/kassa-page/:id",
      "/books-page",
      "/product-page/:id",
      "/add-book-order",
      "/pending-product-orders",
      "/completed-product-orders",
      "/product-order/:orderNumber",

      "/bank-dashboard",
      "/bank-analyze-invoice",
      "/banks-invoices-applications",
      "/foreignBanks",
      "/bank-suppliers",
      "/bank-subcompanies",
      "/bank-subcompanies/:id",
      "/bank-suppliers/:id",
      "/bank-suppliers/:id",
      // "/employee-entitlements",

      "/s3-file-management",
    ];
    return headerRoutes.some((route) => path.match(route));
  };

  function ProtectedResetPassword() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const id = searchParams.get("id");

    if (token && id) {
      return <ResetPassword />;
    } else {
      return <Navigate to="/page-not-found" />;
    }
  }

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("adminToken");
    localStorage.removeItem("SuperAdminToken");

    localStorage.removeItem("userType");

    localStorage.removeItem("userId");
    localStorage.removeItem("supplierId");
    localStorage.removeItem("customerId");
    localStorage.removeItem("email");
    localStorage.removeItem("username");
    localStorage.removeItem("phoneNumber");
    localStorage.removeItem("organizationId");
    localStorage.removeItem("organizationType");
    localStorage.removeItem("organizationName");
    localStorage.removeItem("subCompany");

    setIsAuthenticated(null);
    setIsAuthenticatedAdmin(null);
  };

  // Utility function to check if the token is expired
  const isTokenExpired = (token) => {
    try {
      const decodedToken = jwt_decode(token);
      const currentTime = Date.now() / 1000;
      return decodedToken.exp < currentTime;
    } catch (error) {
      console.error("Failed to decode token", error);
      return true; // If there's an error decoding, consider the token expired
    }
  };

  // Check for valid token on initial load and whether it's expired
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = localStorage.getItem("token");
    return token && !isTokenExpired(token); // Check if token is valid and not expired
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && isTokenExpired(token)) {
      logout();
    }
  }, []);

  const [isAuthenticatedAdmin, setIsAuthenticatedAdmin] = useState(() => {
    const adminToken =
      localStorage.getItem("SuperAdminToken") ||
      localStorage.getItem("adminToken") ||
      localStorage.getItem("token");
    return adminToken ? true : false; // If there's a token, user is authenticated
  });

  const ProtectedRoute = ({ isAuthenticated, children }) => {
    return isAuthenticated ? children : <Navigate to="/login" />;
  };

  const AdminProtectedRoute = ({ children }) => {
    return isAuthenticatedAdmin ? children : <Navigate to="/admin-login" />;
  };

  return (
    <Router>
      <>
        <Routes>
          <Route
            path="*"
            element={
              <UserAuthProvider>
                <Routes>
                  <Route
                    path="/squad-dashboard"
                    element={<Navigate to="/calculate-attendance" replace />}
                  />
                  <Route
                    path="/ai-organization-dashboard"
                    element={<Navigate to="/bank-invoices" replace />}
                  />

                  <Route
                    path="/ai-organization-dashboard/invoices"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<AIOrganizationInvoicesPage />}
                          showHeader={getShowHeader("/dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/ai-organization-dashboard/invoices/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<AIOrganizationInvoicePage />}
                          showHeader={getShowHeader("/dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/bankApplications/:id/payments"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<ViewInvoicePage />}
                          showHeader={getShowHeader("/dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/companyAnalyzeApplication"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<CompanyAnalyzeApplicationPage />}
                          showHeader={getShowHeader("/dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/bankApplications/:id/payments/:paymentId"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<ViewInvoicePaymentsPage />}
                          showHeader={getShowHeader("/dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/bank-invoices"
                    element={
                      <ProtectedRoute
                        isAuthenticated={
                          isAuthenticatedAdmin || isAuthenticated
                        }
                      >
                        <Layout
                          element={<BankInvoicesPage />}
                          showHeader={getShowHeader("/banks-page")}
                          setIsAuthenticated={
                            isAuthenticatedAdmin
                              ? setIsAuthenticatedAdmin
                              : setIsAuthenticated
                          }
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/bank-invoices/:id"
                    element={
                      <ProtectedRoute
                        isAuthenticated={
                          isAuthenticatedAdmin || isAuthenticated
                        }
                      >
                        <Layout
                          element={<BankInvoicePage />}
                          showHeader={getShowHeader("/banks-page")}
                          setIsAuthenticated={
                            isAuthenticatedAdmin
                              ? setIsAuthenticatedAdmin
                              : setIsAuthenticated
                          }
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/subscription-page"
                    element={
                      <AdminProtectedRoute
                        isAuthenticatedAdmin={isAuthenticatedAdmin}
                      >
                        <Layout
                          element={<ManageSubscriptions />}
                          showHeader={getShowHeader("/admin-dashboard")}
                          setIsAuthenticated={setIsAuthenticatedAdmin}
                        />
                      </AdminProtectedRoute>
                    }
                  />
                  <Route
                    path="/admin-dashboard"
                    element={<Navigate to="/iraqi-banks-page" replace />}
                  />
                  <Route
                    path="/bug-reports"
                    element={
                      <AdminProtectedRoute
                        isAuthenticatedAdmin={isAuthenticatedAdmin}
                      >
                        <Layout
                          element={<BugReportsList />}
                          showHeader={getShowHeader("/admin-dashboard")}
                          setIsAuthenticated={setIsAuthenticatedAdmin}
                        />
                      </AdminProtectedRoute>
                    }
                  />
                  <Route
                    path="/bug-reports/:id"
                    element={
                      <AdminProtectedRoute
                        isAuthenticatedAdmin={isAuthenticatedAdmin}
                      >
                        <Layout
                          element={<BugReportDetails />}
                          showHeader={getShowHeader("/admin-dashboard")}
                          setIsAuthenticated={setIsAuthenticatedAdmin}
                        />
                      </AdminProtectedRoute>
                    }
                  />

                  <Route
                    path="/s3-file-management"
                    element={
                      <AdminProtectedRoute
                        isAuthenticatedAdmin={isAuthenticatedAdmin}
                      >
                        <Layout
                          element={<S3FileManagement />}
                          showHeader={getShowHeader("/admin-dashboard")} // Using admin dashboard header for now
                          setIsAuthenticated={setIsAuthenticatedAdmin}
                        />
                      </AdminProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard"
                    element={<Navigate to="/invoiceManagement" replace />}
                  />
                  <Route
                    path="/school-dashboard"
                    element={<Navigate to="/students" replace />}
                  />
                  <Route
                    path="/add-order"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<AddOrder />}
                          showHeader={getShowHeader("/school-dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/add-uniform-order"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <AddUniformOrder
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/school-dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/uniform-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<UniformPage />}
                          showHeader={getShowHeader("/school-dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/belongings"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<Belongings />}
                          showHeader={getShowHeader("/school-dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/students"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<StudentsPage />}
                          showHeader={getShowHeader("/students")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/delivered-supplies"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<DeliveredSuppliesPage />}
                          showHeader={getShowHeader("/students")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/delivered-supplies/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<DeliveredSuppliesItmePage />}
                          showHeader={getShowHeader("/students")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/student-profile/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<StudentProfile />}
                          showHeader={getShowHeader("/student-profile/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/student-profile/:id/supplies"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<StudentSupplies />}
                          showHeader={getShowHeader("/student-profile/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/education-stages"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<EducationStagesPage />}
                          showHeader={getShowHeader("/education-stages")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/discounts-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<DiscountsPage />}
                          showHeader={getShowHeader("/discounts-page")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/entitlements-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<EntitlementsPage />}
                          showHeader={getShowHeader("/discounts-page")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/deductions-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<DeductionsPage />}
                          showHeader={getShowHeader("/discounts-page")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/employee-attendance/:id/entitlements"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<EmployeeEntitlementsPage />}
                          showHeader={getShowHeader("/employee-entitlements")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/kassat-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<KassatPage />}
                          showHeader={getShowHeader("/kassat-page")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/kassa-page/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<KassaPage />}
                          showHeader={getShowHeader("/kassa-page/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/books-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<BooksPage />}
                          showHeader={getShowHeader("/books-page")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/books-page/book-page/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <BookPage setIsAuthenticated={setIsAuthenticated} />
                          }
                          showHeader={getShowHeader(
                            "/books-page/book-page/:id"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/revenues"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <RevenuesPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/school-dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/expenses"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ExpensesPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/school-dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/product-page/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ProductPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/product-page/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/add-book-order"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <AddBookOrder
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/add-book-order")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/supplies"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <AddSuppliesOrder
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/add-book-order")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/pending-product-orders"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <InCompleteProductOrders
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/pending-product-orders")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/completed-product-orders"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <CompletedProductOrders
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/completed-product-orders"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/product-order/:orderNumber"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ProductOrdersPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/product-order/:orderNumber"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/viewSuppliersPage"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<SuppliersPage />}
                          showHeader={getShowHeader("/viewSuppliersPage")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/editContainer/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<EditContainer />}
                          showHeader={getShowHeader("/editContainer/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/invoiceManagement"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <InvoicesManagement
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/message-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <MessagePage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/message-page")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/merchant-dashboard"
                    element={<Navigate to="/invoicesOfShippedContainers" replace />}
                  />
                  <Route
                    path="/no_customer_merchant-dashboard"
                    element={<Navigate to="/noCustomerInvoices" replace />}
                  />
                  <Route
                    path="/banks-page"
                    element={
                      <ProtectedRoute
                        isAuthenticated={
                          isAuthenticatedAdmin || isAuthenticated
                        }
                      >
                        <Layout
                          element={
                            <BanksPage
                              setIsAuthenticated={
                                setIsAuthenticatedAdmin || setIsAuthenticated
                              }
                            />
                          }
                          showHeader={getShowHeader("/banks-page")}
                          setIsAuthenticated={
                            isAuthenticatedAdmin
                              ? setIsAuthenticatedAdmin
                              : setIsAuthenticated
                          }
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/banks-with-transactions"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <BanksWithTransaction
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/banks-with-transactions")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/organizations-page"
                    element={
                      <AdminProtectedRoute
                        isAuthenticated={isAuthenticatedAdmin}
                      >
                        <Layout
                          element={
                            <OrganizationsPage
                              setIsAuthenticated={setIsAuthenticatedAdmin}
                            />
                          }
                          showHeader={getShowHeader("/organizations-page")}
                          setIsAuthenticated={setIsAuthenticatedAdmin}
                        />
                      </AdminProtectedRoute>
                    }
                  />
                  <Route
                    path="/iraqi-banks-page"
                    element={
                      <AdminProtectedRoute>
                        <Layout
                          element={
                            <IraqiBanksPage
                              setIsAuthenticated={setIsAuthenticatedAdmin}
                            />
                          }
                          showHeader={getShowHeader("/iraqi-banks-page")}
                          setIsAuthenticated={setIsAuthenticatedAdmin}
                        />
                      </AdminProtectedRoute>
                    }
                  />
                  <Route
                    path="/previewItemInvoiceTemplate"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PreviewItemInvoiceTemplate
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/merchant-dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/supermarket-dashboard"
                    element={<Navigate to="/cashier" replace />}
                  />
                  <Route
                    path="/cashier"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <Cashier setIsAuthenticated={setIsAuthenticated} />
                          }
                          showHeader={getShowHeader("/cashier")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/manual-customers-cashier"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ManualCustomersCashier
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/manual-customers-cashier"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/inventory"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <Inventory
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/inventory")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/sell-invoices"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <SellInvoices
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/sell-invoices")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/development"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <Development
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/development")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/issuedAndImportedBooks"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <IssuedAndImportedBooks
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/dashboard")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/issuedBooks"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <IssuedBooks
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/issuedBooks")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/employees"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <Employees
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/employees")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/clinicEmployees"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ClinicEmployees
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/clinicEmployees")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/containerPrices"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<ContainerPrices />}
                          showHeader={getShowHeader("/containerPrices")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/invoice/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<ViewInvoice />}
                          showHeader={getShowHeader("/invoice/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/CreateInvoiceOfMultiContsPage"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          showHeader={getShowHeader("/print")}
                          element={<CreateInvoiceOfMultiContsPage />}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/createNoCustomerInvoice"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          showHeader={getShowHeader("/print")}
                          element={<CreateNoCustomerInvoice />}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/print"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<PrintInvoices />}
                          showHeader={getShowHeader("/print")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/bankApplications"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<BankApplications />}
                          showHeader={getShowHeader("/dashboard")}
                          setIsAuthenticated={isAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/printDocuments"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<PrintDocuments />}
                          showHeader={getShowHeader("/printDocuments")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <ProtectedRoute
                        isAuthenticated={
                          isAuthenticatedAdmin || isAuthenticated
                        }
                      >
                        <Layout
                          element={<Profile />}
                          showHeader={getShowHeader("/profile")}
                          setIsAuthenticated={
                            isAuthenticatedAdmin
                              ? setIsAuthenticatedAdmin
                              : setIsAuthenticated
                          }
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/viewSuppliersPage"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<SuppliersPage />}
                          showHeader={getShowHeader("/viewSuppliersPage")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/customers"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<CustomersPage />}
                          showHeader={getShowHeader("/customersPage")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/fabric-customers"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<FabricCustomers />}
                          showHeader={getShowHeader("/customersPage")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/abstract-customers-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<AbstractCustomersPage />}
                          showHeader={getShowHeader("/customersPage")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/patients-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<PatientsPage />}
                          showHeader={getShowHeader("/customersPage")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/noCustomerInvoices"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<NoCustomerInvoices />}
                          showHeader={getShowHeader(
                            "/invoicesOfShippedContainers"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/orgShippedContainers"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<OrgShippedContainers />}
                          showHeader={getShowHeader("/orgShippedContainers")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/noCustomerContainers"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<NoCustomerContainers />}
                          showHeader={getShowHeader("/orgShippedContainers")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/invoicesOfShippedContainers"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<InvoicesOfShippedContainers />}
                          showHeader={getShowHeader(
                            "/invoicesOfShippedContainers"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/shippedContainer/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<ViewShippedContainer />}
                          showHeader={getShowHeader("/shippedContainer/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/noCustomerContainer/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<ViewNoCustomerContainer />}
                          showHeader={getShowHeader("/shippedContainer/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/viewMultiContainerInvoice/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<ViewMultiContainerInvoice />}
                          showHeader={getShowHeader("/shippedContainer/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/viewNoCustomerInvoice/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<ViewNoCustomerInvoice />}
                          showHeader={getShowHeader("/shippedContainer/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/subCompanies"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<SubCompanies />}
                          showHeader={getShowHeader("/print")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/analyzedinvoice"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          showHeader={getShowHeader("/subCompanies")}
                          element={<AnalyzedInvoice />}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/analyzedNoCustomerInvoice"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          showHeader={getShowHeader("/subCompanies")}
                          element={<AnalyzedNoCustomerInvoice />}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/analyzepdf"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={<AnalyzePdf />}
                          showHeader={getShowHeader("/analyzepdf")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/clinic-dashboard"
                    element={<Navigate to="/appointments" replace />}
                  />
                  <Route
                    path="/treatmentsPage"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <TreatmentsPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/treatmentsPage")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/appointments"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <Appointments
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/appointments")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/doctors"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <DoctorsPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/doctors")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/patient-profile/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PatientProfile
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/patient-profile/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  {/* route for ItemInvoices page */}
                  <Route
                    path="/ItemInvoices"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ItemInvoices
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/itemInvoices")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/ItemInvoice/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ViewItemInvoice
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/ItemInvoice")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/previewItemInvoice/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PreviewItemInvoice
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/ItemInvoice")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/manual-cashier"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ManualCashier
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/manual-cashier")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  {/*  fabrics */}
                  <Route
                    path="/fabricstore-dashboard"
                    element={<Navigate to="/rulers" replace />}
                  />
                  <Route
                    path="/rulers"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ManageRulersAndColors
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/rulers")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/incompleteFabricOrders-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <InCompleteFabricOrders
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/incompleteFabricOrders-page"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/completeFabricOrders-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <CompleteFabricOrders
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/completeFabricOrders-page"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/fabric-order/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <FabricOrderPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/fabric-order-page")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/addFabricOrder-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <AddFabricOrderPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/addFabricOrder-page")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/rulers/color-page/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ColorPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/rulers/color-page/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/fabric-cashier"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <FabricStoreCashier
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/fabric-cashier")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/fabric-sellInvoices"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <FabricSellInvoices
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/fabric-sellInvoices")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/fabric-customers-cashier"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <FabricCustomersCashier
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/fabric-customers-cashier"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/fabric-sell-invoice/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ViewSellInvoice
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/fabric-sell-invoice/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/attendance-dashboard"
                    element={<Navigate to="/calculate-attendance" replace />}
                  />
                  <Route
                    path="/calculate-attendance"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <CalculateAttendance
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/calculate-attendance")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/attendance-employees"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <EmployeesAttendance
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/attendance-employees")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/employee-attendance/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <EmployeeAttendancePage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/employee-attendance/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/employees-progress"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <EmployeesProgress
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/employees-progress")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  {/* paper company */}
                  <Route
                    path="/paperFactory-dashboard"
                    element={<Navigate to="/manage-paper-rulers" replace />}
                  />
                  <Route
                    path="/manage-paper-rulers"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ManagePaperRulers
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/manage-paper-rulers")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/add-paper-order"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <AddPaperOrderPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/add-paper-order")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/incomplete-paper-order"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <IncompletePaperOrders
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/incomplete-paper-order")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/completed-paper-orders"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <CompletedPaperOrders
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/completed-paper-orders")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/add-internal-order-page"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <InternalAddPaperOrderPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/add-internal-order-page")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/incomplete-internal-orders"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <InternalInCompletePaperOrders
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/incomplete-internal-orders"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/completed-internal-orders"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <InternalCompletedPaperOrders
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/completed-internal-orders"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/internal-paper-order-page/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <InternalPaperOrderPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/internal-paper-order-page/:id"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/papers-rulers"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PaperRulers
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/papers-rulers")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/paper-order-page/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PaperOrderPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/paper-order-page")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/paper-store-cashier"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PaperStoreCashier
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/paper-store-cashier")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/paper-customer-cashier"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PaperCustomersCashier
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/paper-customer-cashier")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/paper-sellInvoices"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PaperSellInvoices
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/paper-sellInvoices")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/paper-sell-invoice/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ViewPaperSellInvoice
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/paper-sell-invoice/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/manage-paper-rulers/paper-page/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PaperPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/manage-paper-rulers/paper-page/:id"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/pending-orders"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PendingOrders
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/pending-orders")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/prepared-orders"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PreparedOrders
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/prepared-orders")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/pending-orders/paper-invoice/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <PaperInvoicePage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/pending-orders/paper-invoice/:id"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/bank-analyze-invoice"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <BanksAnalyzeInvoice
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/bank-analyze-invoice")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/bank-dashboard"
                    element={<Navigate to="/banks-invoices-applications" replace />}
                  />
                  <Route
                    path="/banks-invoices-applications"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <BanksInvoicesApplications
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/banks-invoices-applications"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/banks-invoices-applications/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <BanksInvoicesApplicationPayments
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/banks-invoices-applications"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/banks-invoices-applications/:id/payments/:paymentId"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <BanksInvoicesApplicationPaymentDetails
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader(
                            "/banks-invoices-applications"
                          )}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/bank-suppliers"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <BankSuppliersPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/bank-suppliers")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/bank-suppliers/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ViewSupplier
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/bank-suppliers/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/bank-subcompanies"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <BankIraqiCompaniesPage
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/bank-subcompanies")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/bank-subcompanies/:id"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ViewSubCompany
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/bank-subcompanies/:id")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/foreignBanks"
                    element={
                      <ProtectedRoute isAuthenticated={isAuthenticated}>
                        <Layout
                          element={
                            <ForeignBanks
                              setIsAuthenticated={setIsAuthenticated}
                            />
                          }
                          showHeader={getShowHeader("/foreignBanks")}
                          setIsAuthenticated={setIsAuthenticated}
                        />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/whatsapp-page"
                    element={
                      <AdminProtectedRoute
                        isAuthenticatedAdmin={isAuthenticatedAdmin}
                      >
                        <Layout
                          element={
                            <WhatsAppPage
                              setIsAuthenticated={setIsAuthenticatedAdmin}
                            />
                          }
                          showHeader={getShowHeader("/whatsapp-page")}
                          setIsAuthenticated={setIsAuthenticatedAdmin}
                        />
                      </AdminProtectedRoute>
                    }
                  />

                  <Route
                    path="/todolist-page"
                    element={
                      <AdminProtectedRoute
                        isAuthenticatedAdmin={isAuthenticatedAdmin}
                      >
                        <Layout
                          element={
                            <TodoListPage
                              setIsAuthenticated={setIsAuthenticatedAdmin}
                            />
                          }
                          showHeader={getShowHeader("/todolist-page")}
                          setIsAuthenticated={setIsAuthenticatedAdmin}
                        />
                      </AdminProtectedRoute>
                    }
                  />

                  <Route
                    path="/hs-codes-page"
                    element={
                      <AdminProtectedRoute
                        isAuthenticatedAdmin={isAuthenticatedAdmin}
                      >
                        <Layout
                          element={
                            <HsCodePage
                              setIsAuthenticated={setIsAuthenticatedAdmin}
                            />
                          }
                          showHeader={getShowHeader("/hs-codes-page")}
                          setIsAuthenticated={setIsAuthenticatedAdmin}
                        />
                      </AdminProtectedRoute>
                    }
                  />

                  <Route path="*" element={<MissingPage />} />
                  <Route
                    path="/subscription-plans"
                    element={
                      <AdminProtectedRoute
                        isAuthenticatedAdmin={isAuthenticatedAdmin}
                      >
                        <Layout
                          element={
                            <SubscriptionPlans
                              setIsAuthenticated={setIsAuthenticatedAdmin}
                            />
                          }
                          showHeader={getShowHeader("/admin-dashboard")}
                          setIsAuthenticated={setIsAuthenticatedAdmin}
                        />
                      </AdminProtectedRoute>
                    }
                  />
                  <Route
                    path="/admins"
                    element={
                      <AdminProtectedRoute
                        isAuthenticatedAdmin={isAuthenticatedAdmin}
                      >
                        <Layout
                          element={<AdminsPage />}
                          showHeader={getShowHeader("/admin-dashboard")}
                          setIsAuthenticated={setIsAuthenticatedAdmin}
                        />
                      </AdminProtectedRoute>
                    }
                    showHeader={getShowHeader("/admin-dashboard")}
                  />
                </Routes>
              </UserAuthProvider>
            }
          />

          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route
            path="/admin-login"
            element={
              <AdminsLogin
                isAuthenticatedAdmin={isAuthenticatedAdmin}
                setIsAuthenticatedAdmin={setIsAuthenticatedAdmin}
              />
            }
          />
          <Route path="/users" element={<UsersPage />} />

          <Route path="/register" element={<Register />} />
          <Route
            path="/login"
            element={
              <Login
                isAuthenticated={isAuthenticated}
                isAuthenticatedAdmin={isAuthenticatedAdmin}
                setIsAuthenticated={setIsAuthenticated}
              />
            }
          />

          <Route path="/cashier-system" element={<CashierSystem />} />
          {/* <Route path="/manual-cashier" element={<ManualCashier />} /> */}
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/successPage" element={<SuccessPage />} />
          <Route path="/forget-password" element={<ProtectedResetPassword />} />

          <Route path="/projects" element={<ProjectDashboard />} />
        </Routes>
      </>
    </Router>
  );
};

export default App;
